module.exports = __webpack_public_path__ + "img/q23c4c-l3.prt.e77dd385.jpg";